<template>
  <v-card>
    <v-card-title class="pa-2 subtitle-1 pb-0">
      <b>Timeline</b>
      <v-spacer />
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            icon
            :color="sync ? 'primary': null"
            v-bind="attrs"
            v-on="on"
            @click="syncFilters = !syncFilters"
          >
            <v-icon
              small
            >
              {{ syncFilters ? mdiSync : mdiSyncOff }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ syncFilters ? "Filters are synchronized" : "Filters are not synchronized" }}</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text class="pa-2 ma-0">
      <session-filters
        ref="filters"
        :map-id="mapId"
        :filtersValue="selectedTimelineData"
        :validation="true"
        :use-narration-nodes="true"
        :update-narration-nodes-list="['session_id']"
        @update="updateTimelineFilters"
      />
      <div class="pt-1 d-flex justify-center">
        <v-btn
          color="primary"
          @click="showTimeLineControl"
        >
          show timeline
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiSync, mdiSyncOff } from '@mdi/js';
import { showTimelineControl } from '../../../plugins/click-layers-functions'
import SessionFilters from '../../filters/Telemetry/SessionFilters.vue'
export default {
  props: {
    map: {
      type: Object,
      required: true
    },
    sync: {
      type: Boolean,
      required: true
    }
  },
  components: {
    SessionFilters
  },
  data () {
    return {
      mdiSync,
      mdiSyncOff,
      mapId: this.map.options.currentMapId,
      selectedTimelineData: {
        build_id: this.$store.state.telemetry.build_id,
        user_id: this.$store.state.telemetry.user_id,
        session_id: this.$store.state.telemetry.session_id,
        start_narration_node: this.$store.state.telemetry.start_narration_node,
        finish_narration_node: this.$store.state.telemetry.finish_narration_node
      }
    }
  },
  computed: {
    syncFilters: {
      get () {
        return this.sync
      },
      set (val) {
        this.$emit('set-sync', [val, 'Timeline', 'Heatmaps'])
      }
    }
  },
  async mounted () {
    this.map.on('change-map-id', this.changeMapId)
  },
  beforeDestroy () {
    this.map.off('change-map-id', this.changeMapId)
  },
  methods: {
    changeMapId () {
      this.mapId = this.map.options.currentMapId
      this.selectedTimelineData = {
        build_id: null,
        user_id: null,
        session_id: null,
        start_narration_node: null,
        finish_narration_node: null
      }
    },
    async showTimeLineControl () {
      const isValid = await this.$refs.filters.validate()
      if (isValid) {
        const func = showTimelineControl.bind(this)
        await func({ ...this.selectedTimelineData })
      }
    },
    updateTimelineFilters (data) {
      this.selectedTimelineData = { ...this.selectedTimelineData, ...data }
      if (this.sync) {
        this.$emit('sync-filters', [{ ...this.selectedTimelineData }, 'Heatmaps'])
      }
    }
  }
}
</script>